<template>
  <div id="timeline_container">
    <ul class="timeline" id="timeline">
      <li class="li" :class="[isAfter($moment(mainStore.module.date_debut_inscription)) ? 'complete' : '']">
        <div class="timestamp">
          <p class="text-subtitle-1 font-weight-bold">
            {{ $moment(mainStore.module.date_debut_inscription).format("ddd DD/MM") }}</p>
          <p class="text-subtitle-2">{{ mainStore.module.heure_debut_inscription }}</p>
        </div>
        <div class="status">
          <div class="pa-2 bordered shadowed rounded font-weight-bold">
            <p>Ouverture des inscriptions</p>
          </div>
        </div>
      </li>

      <li v-if="!mainStore.billetterie" class="li" :class="[isAfter(get_j_minus(30)) ? 'complete' : '']">
        <div class="timestamp">
          <p class="text-subtitle-1 font-weight-bold">{{ $moment(get_j_minus(30)).format("ddd DD/MM") }}</p>
          <p class="text-subtitle-2">J-30</p>
        </div>
        <div class="status">
          <div class="pa-2 bordered shadowed rounded font-weight-bold">
            <p>Création du visuel dossard</p>
          </div>
        </div>
      </li>
      <li v-if="!mainStore.billetterie_mode" class="li" :class="[isAfter(get_j_minus(13)) ? 'complete' : '']">
        <div class="timestamp">
          <p class="text-subtitle-1 font-weight-bold">{{ $moment(get_j_minus(13)).format("ddd DD/MM") }}</p>
          <p class="text-subtitle-2">J-13</p>
        </div>
        <div class="status">
          <div class="pa-2 bordered shadowed rounded font-weight-bold">
            <p>Lancement de l'impression dossard<br />Fixer les quantités</p>
          </div>
        </div>
      </li>
      <li class="li" :class="[isAfter($moment(mainStore.module.date_fin_inscription)) ? 'complete' : '']">
        <div class="timestamp">
          <p class="text-subtitle-1 font-weight-bold">
            {{ $moment(mainStore.module.date_fin_inscription).format("ddd DD / MM") }}</p>
          <p class="text-subtitle-2">{{ mainStore.module.heure_fin_inscription }}</p>
        </div>
        <div class="status">
          <div class="pa-2 bordered shadowed rounded font-weight-bold">
            <p>Cloture des inscriptions</p>
          </div>
        </div>
      </li>
      <li class="li">
        <div class="timestamp">
          <p class="text-subtitle-1 font-weight-bold">
            {{ $moment(mainStore.module.evenement.date_debut).format("ddd DD / MM") }}</p>
          <p class="text-subtitle-2">{{ $moment(mainStore.module.evenement.date_fin).format("ddd DD/MM") }}</p>
        </div>
        <div class="status">
          <div class="pa-2 bordered shadowed rounded font-weight-bold">
            <p>Jour J</p>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapStores } from 'pinia';
import { useMainStore } from '@/stores/mainStore';
export default {
  computed: {
    ...mapStores(useMainStore),
  },
  methods: {
    isAfter(date_item) {
      return this.$moment().isAfter(date_item);
    },
    get_j_minus(nb_jours) {
      return this.$moment(this.mainStore.module.evenement.date_debut).subtract(nb_jours, "days");
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/Timeline.scss";
</style>